export default "__VITE_ASSET__B$os4Ybm__"